// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Vopm","productName":"Table_productName__IDZjW"};